import React, { Fragment } from "react"
import { FormattedMessage } from "react-intl"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import "./paper-list.css"

const PaperList = () => (
  <StaticQuery
    query={graphql`
      query {
        allImageSharp {
          edges {
            node {
              id
              fluid {
                src
                aspectRatio
                sizes
                srcSet
                originalName
              }
            }
          }
        }
        allPapersJson {
          edges {
            node {
              id
              title
              cover_image
              download_url
            }
          }
        }
      }
    `}
    render={data => (
      <Fragment>
        {/* <h1 className="paper-title">
      <span>
        <FormattedMessage id="org.massnet.components.research.paper.title" />
      </span>
    </h1> */}
        <div className="paper-list-background">
          <div className="container">
            <h1 className="paper-title">
              <span>
                <FormattedMessage id="org.massnet.components.research.paper.title" />
              </span>
            </h1>
            <div className="paper-list-area">
              {data.allPapersJson.edges.map(({ node }) => (
                <div className="paper-detail" key={node.id}>
                  <div className="paper-list-image">
                    <Img
                      alt="MASS,区块链共识引擎,POC,存储空间租赁,容量证明,共识引擎,挖矿"
                      fluid={
                        data.allImageSharp.edges.find(
                          item =>
                            item.node.fluid.originalName === node.cover_image
                        ).node.fluid
                      }
                    />
                  </div>
                  <p className="paper-detail-title">
                    <a href={node.download_url} download="" target="_blank">
                      <FormattedMessage id={node.title} />
                    </a>
                  </p>
                  <div className="paper-download">
                    <a href={node.download_url} download="" target="_blank">
                      <FormattedMessage id="org.massnet.components.research.paper.download" />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Fragment>
    )}
  />
)

export default PaperList
